<template>
  <div>
    <!-- excel下单 -->
    <el-dialog :title="$t('message.excelOrder')" :close-on-click-modal="false"
      :visible.sync="$parent.excelOrderDialogVisible" width="1142px" center>
      <div class="addGoods">
        <!-- 订单类别 -->
        <div class="type">
          <!-- 订单类别 -->
          <span>{{ $t("message.orderType") }} :</span>
          <!-- 单选 -->
          <div class="radio">
            <el-radio-group v-model="type">
              <!-- 普通订单 -->
              <el-radio :label="item.key" v-for="(item, index) in typeList" :key="index">{{ item.value
              }}</el-radio>
            </el-radio-group>
          </div>
          <!-- 客户ID： -->
          <span>{{ $t("message.userID") }} :</span>
          <div class="input">
            <el-input v-model="user_id" size="small" onfocus="this.select()" type="number"
              @blur="clientList"></el-input>
          </div>
          <!-- 客户ID： -->
          <span style="margin-left: 5px;">{{ $t("message.userName") }} :{{ userName }}</span>
        </div>
        <div class="row">
          <!-- 上传 -->
          <el-upload class="upload-demo" drag :action="baseURL + '/order.excelOrder'" multiple :show-file-list="false"
            :data="{ user_id: user_id, type: type }" :headers="{
              AdminToken: 'Bearer ' + token
            }" :on-success="handleAvatarSuccess">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
          <a :href="'https://apiwww.rakumart.com/client/excelOrder.excelOrderTpl?rand=' + rand" class="link">
            <el-button type="primary">EXCLE模板下载</el-button>
          </a>
          <i class="el-icon-tickets" v-if="goods != false"></i>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.excelOrderDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user_id: "",
      userName: '',
      type: "",
      file: '',
      token: localStorage.getItem('japan_access_token'),
      goods: [],
      order_sn: '',
      rand: ''
    };
  },
  computed: {
    typeList() {
      return this.$store.state.typeList;
    },
  },
  created() {

    this.rand = '';
    for (var i = 0; i < 6; i++) {
      this.rand += Math.floor(Math.random() * 10);
    }

  },
  methods: {
    //上传成功
    handleAvatarSuccess(res) {
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)

      this.goods = []
      this.order_sn = res.data.order_sn
      res.data.order_data.forEach(item => {
        item.goods.forEach(items => {
          this.goods.push({
            No: 1,
            detail: items.detail,
            detail_y: [],
            from_platform: items.from_platform,
            goodsId: items.goods_id,
            goods_title: items.goods_title,
            link: "",
            num: items.num,
            pic: items.pic,
            service_rate: 0,
            shop_id: items.shop_id,
            shop_name: items.shop_name,
            show: true,
            price: items.price,
            order_detail_tag: items.order_detail_tag,
            client_remark: items.client_remark,
            for_sn: items.for_sn,
          })
        })
      })
    },
    // 保存到预览
    save() {
      if (this.goods == false) return this.$message.error('请上传xlsx文件')
      if (this.user_id == '') return this.$message.error('客户ID缺失')
      this.$parent.excelOrderDialogVisible = false
      let routeUrl = this.$router.resolve({
        path: "/orderPreview?userID=" + this.user_id + "&type=excel" + '&order_sn=' + this.order_sn,
      });
      let data = {
        orderList: this.goods,
        y_reply: '',
        y_remark: '',
      }
      window.open(routeUrl.href, JSON.stringify(data));
    },
    // 格式格式
    beforeAvatarUpload(file) {
      const xlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!xlsx) {
        this.$message.error("只能上传.xlsx");
      }

      return xlsx;
    },
    // 客户名
    clientList() {
      if (this.user_id) {
        this.$api.clienteleApi.clientList({ id: this.user_id }).then((res) => {
          if (res.data.total > 0) {
            this.userName = res.data.data[0].realname
          }
          console.log(res);
        })
      }
    },

  }
}
</script>
<style lang='scss' scoped>
.addGoods {
  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .type {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;
    margin-bottom: 30px;

    .radio {
      margin-right: 80px;
    }

    span {
      margin-right: 20px;
    }

    .input {
      width: 100px;
    }
  }


  .row {
    display: flex;
    position: relative;

    .link {
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .el-icon-tickets {
      font-size: 180px;
      margin-left: 20px;
    }
  }

}
</style>